import { Section } from 'model/section'

export const getAnswer = (sections: Section[] | undefined, sectionName: string, questionText: string): string => {
  const section = sections?.find(s => s.section === sectionName)
  const question = section?.questions?.find(q => q.questionText === questionText)
  return question?.answer?.answerText ?? ''
}
